enum EditMode {
    Write = 0,
    ReadOnly = 1,
    DeleteOnly = 2
}

export default EditMode;
